import { Box } from '@mui/material';
import { AnimatePresence } from 'motion/react';
import { FC, Fragment } from 'react';

import MagicWandFilled from '@vp/assets/icons/MagicWandFilled.svg?react';
import { VpButton } from '@vp/common/ui/component/VpButton';
import { VpDialog } from '@vp/common/ui/component/VpDialog';
import { VpFade } from '@vp/common/ui/component/VpFade';
import { useViewModel } from '@vp/common/ui/hook/useViewModel';
import { AvatarImagePlaceholder } from '@vp/manager/avatar/ui/AvatarImagePlaceholder';
import { AvatarManagerHeader } from '@vp/manager/avatar/ui/AvatarManagerHeader';
import { AvatarManagerImage } from '@vp/manager/avatar/ui/AvatarManagerImage';
import { AvatarManagerViewModel } from '@vp/manager/avatar/ui/AvatarManagerViewModel';

export const AvatarManagerPage: FC = () => {
  const viewModel = useViewModel(AvatarManagerViewModel);

  return (
    <Fragment>
      <VpFade sx={{ height: '100dvh', width: 1 }}>
        <AvatarManagerHeader />

        <Box
          sx={theme => ({
            [theme.breakpoints.up('tablet')]: {
              width: 1,
              height: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            },
          })}
        >
          <AnimatePresence mode="wait">
            <VpFade
              duration={0.25}
              key={viewModel.profile.value!.image.url}
              sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: { mobile: 1, tablet: 391 } }}
            >
              {viewModel.showImage.value && (
                <Fragment>
                  <AvatarManagerImage
                    src={viewModel.profile.value!.image.url}
                    hash={viewModel.profile.value!.image.hash}
                    onCloseClick={viewModel.onRemoveButtonClick}
                  />

                  <VpButton
                    text={viewModel.animateButtonText.value}
                    status="overlay"
                    variant="soft"
                    size="small"
                    sx={{ mx: { mobile: 3, tablet: 0 } }}
                    Icon={MagicWandFilled}
                    disabled={viewModel.animateButtonDisabled.value}
                    loading={viewModel.animateButtonLoading.value}
                    onClick={viewModel.onAnimateButtonClick}
                  />
                </Fragment>
              )}

              {!viewModel.showImage.value && (
                <AvatarImagePlaceholder uploading={viewModel.uploading.value} onFileUpload={viewModel.onFileUpload} />
              )}
            </VpFade>
          </AnimatePresence>
        </Box>
      </VpFade>

      <VpDialog
        open={viewModel.deleteDialogShown.value}
        title="Удалить фото профиля"
        text="Вы уверены, что хотите удалить фото профиля? Это действие нельзя отменить."
        actionText="Удалить"
        cancelText="Отменить"
        maxWidth={450}
        actionLoading={viewModel.removing.value}
        cancelDisabled={viewModel.removing.value}
        onAction={viewModel.removeImage}
        onCancel={viewModel.closeDeleteDialog}
      />

      <VpDialog
        maxWidth={450}
        open={viewModel.animateDialogShown.value}
        title={`Анимировать фото профиля`}
        text={viewModel.animateDialogText.value}
        actionText="Анимировать"
        cancelText="Отменить"
        actionLoading={viewModel.animating.value}
        cancelDisabled={viewModel.animating.value}
        onAction={viewModel.animate}
        onCancel={viewModel.closeAnimateDialog}
      />

      <VpDialog
        maxWidth={450}
        open={viewModel.makeStaticDialogShown.value}
        title={`Вернуть изначальное фото профиля`}
        text={
          'Анимация будет отменена, и фото профиля вернётся к исходному виду. При повторной анимации лимит не уменьшится, так как анимированное фото профиля уже сохранено.'
        }
        actionText="Вернуть"
        cancelText="Отменить"
        actionLoading={viewModel.makingStatic.value}
        cancelDisabled={viewModel.makingStatic.value}
        onAction={viewModel.makeStatic}
        onCancel={viewModel.closeMakeStaticDialog}
      />
    </Fragment>
  );
};
